import { Check, Info, TriangleAlert, X } from 'lucide-react';
import { toast } from 'sonner';

type ToastType = 'success' | 'error' | 'info' | 'warning';

export function useToast() {
  function show(type: ToastType, title: string, message?: string) {
    const icons = {
      success: <Check className="size-[18px]" />,
      error: <X className="size-[18px]" />,
      warning: <TriangleAlert className="size-[18px]" />,
      info: <Info className="size-[18px]" />,
    };

    toast(title, {
      description: message,
      icon: icons[type],
      position: 'bottom-right',
      duration: type === 'error' ? 4000 : 2400,
    });
  }

  function success(message: string, title = 'Sucesso') {
    show('success', title, message);
  }

  function error(message: string, title = 'Erro') {
    show('error', title, message);
  }

  function info(message: string, title = 'Informação') {
    show('info', title, message);
  }

  function warning(message: string, title = 'Atenção') {
    show('warning', title, message);
  }

  return {
    show,
    success,
    error,
    info,
    warning,
  };
}
